/**
 * Fetches the full instrument definitions once (single source of truth for
 * instrument texts and severity bands — never frontend i18n).
 */
import { useEffect, useState } from "react";
import { API_BASE } from "../../config";
import { useAuth } from "../../auth/AuthProvider";
import type { InstrumentDefinition } from "./types";

export function useInstruments() {
  const { ensureToken } = useAuth();
  const [instruments, setInstruments] = useState<InstrumentDefinition[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await ensureToken();
        const resp = await fetch(`${API_BASE}/questionnaires/instruments`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await resp.json();
        if (!resp.ok) throw new Error(data?.error || `HTTP ${resp.status}`);
        if (!cancelled) setInstruments(data.instruments);
      } catch (e: any) {
        if (!cancelled) setError(String(e?.message || e));
      }
    })();
    return () => { cancelled = true; };
  }, [ensureToken]);

  const byId = (id?: string) => instruments?.find((i) => i.instrument_id === id);
  return { instruments, byId, error };
}
